<template>
    <div>
        <div v-for="(nuPointSprayModel, index) in filteredWithholding" :key="'NW' + index">
            <h6>WITHOLD</h6>
            <strong>To:</strong> {{nuPointSprayModel.WitholdingTo | formatDateTime }} <br />
            <strong>Hrs:</strong> {{calculateHours(nuPointSprayModel) | formatNumberTo2Decimals}}
        </div>
        <div v-for="(nuPointSprayModel, index) in filteredICA" :key="'NI' + index">
            <h6>ICA</h6>
            <strong>From:</strong> {{nuPointSprayModel.ICAProtectedFrom | formatDateTime }} <br />
            <strong>To:</strong> {{nuPointSprayModel.ICAProtectedTo | formatDateTime }}
        </div>                
    </div>
</template>

<script>
import moment from 'moment';
export default {
    props: {
        nuPointSprayModels: {
            type: Array,
            required: true
        },        
        show: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    components: {
    },
    data() {
        return {
        }
    },
    computed: {
        filteredWithholding() {
            let filtered = [];

            this.nuPointSprayModels.filter(s => s.Withholding).forEach(spray => {
                if(!filtered.some(f => f.WitholdingTo == spray.WitholdingTo)) {
                    filtered.push(spray);
                }
            });

            return filtered;
        },
        filteredICA() {
            let filtered = [];

            this.nuPointSprayModels.filter(s => s.ICA).forEach(spray => {
                if(!filtered.some(f => f.ICAProtectedFrom == spray.ICAProtectedFrom && f.ICAProtectedTo == spray.ICAProtectedTo)) {
                    filtered.push(spray);
                }
            });

            return filtered;
        }
    },
    methods: {
        calculateHours(model) {
            var local = moment.parseZone(model.WitholdingTo);
            var duration = moment.duration(moment.utc(local).diff(moment.utc()));
            var hours = duration.asHours();

            if (hours < 0) {
                hours = 0;
            }   

            return hours;
        }
    }
    
}
</script>
